module.exports = __webpack_public_path__ + "img/riskmanagement-graph2.5ce00d3c.png";